
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { mask } from "vue-the-mask";
import {
  SistemaMixin,
  ValidacaoMixin,
  EmitenteMixin,
} from "@/modules/Application";
import RevendaData, { RevendaDataRequired } from "./RevendaData";
import VueSelect from "vue-select";
import loadsh from "loadsh";
import "vue-select/dist/vue-select.css";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "app-revenda-form",
  props: {
    url: {
      type: String,
    },
    conta: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VueSelect,
  },
  directives: {
    mask,
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, EmitenteMixin],
  watch: {
    cliente(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.form.cnpj_cpf = this.formatCpfCnpj(newValue.cnpj_cpf);
      }
    },
    logo(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.logo = newValue;
      }
    },
  },
  data() {
    return {
      tabIndex: 0,
      form: {},
      cidades: [],
      file: null,
      certificado: null,
      logo: null,
      checkNewCeritificate: true,
      configMoney: settingMoney,
      logomarca: null,
      cidade: null,
      juridica: true,
      cliente: new RevendaData({}),
      urlLogo: null,
    };
  },
  validations: {
    form: RevendaDataRequired,
  },
  async mounted() {
    await this.getDataInit();

    if (!this.isNuts) {
      this.$router.push({ name: "dashboard" });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      this.setLoading(true);
      const id = this.$route.params.id_empresa;
      const data = await this.getDadosRevenda(id);

      this.setLoading(false);

      if (!data.id_empresa || data == null) {
        return this.$toast.error("Cliente não encontrado!");
      }

      this.cliente = new RevendaData(data);
      this.logo = data.logo;
      this.cidade = data.cidade;

      if (data.cnpj_cpf && data.cnpj_cpf.length < 14) {
        this.juridica = false;
      }
      if (this.cliente.cidade) {
        this.setCidade(this.cliente.cidade);
      }
    },
    setCidade(cidade) {
      if (cidade.id_cidade) {
        this.form.id_cidade = cidade.id_cidade;
      }
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: loadsh.debounce(async (loading, search, vm) => {
      const city = await vm.getCidade(search);
      vm.cidades = city;
      loading(false);
    }, 350),
    async consultaCep() {
      const cep = await this.getCep(this.form.cep);

      if (cep.length == 0) {
        this.setLoading(false);
        return;
      }

      this.form.logradouro = cep.logradouro;
      this.form.bairro = cep.bairro;

      if (cep.erro) {
        this.setLoading(false);
        this.$toast.warning("Confira o CEP informado!");
        return;
      }

      const city = await this.getCidadeByUF(cep.localidade, cep.uf);

      this.cidades = city;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },

    setImage(event) {
      this.certificado = event.target.files[0];
      this.checkNewCeritificate = false;
    },

    async setLogomarca(event) {
      this.logomarca = await event.target.files[0];
      this.urlLogo = URL.createObjectURL(this.logomarca);
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_emitente"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        if (!this.validaCpfCnpj(this.form.cnpj_cpf)) {
          return this.$toast.error("CNPJ/CPF informado é inválido!");
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        let cliente = new FormData();

        if (this.form.complemento != null) {
          cliente.append("complemento", this.form.complemento);
        }

        if (this.form.inscrical_municipal != null) {
          cliente.append("inscricao_municipal", this.form.inscrical_municipal);
        }

        if (this.form.nome_fantasia != null) {
          cliente.append("nome_fantasia", this.form.nome_fantasia);
        }

        if (this.form.site != null) {
          cliente.append("site", this.form.site);
        }

        if (this.form.fone != null) {
          cliente.append("fone", this.form.fone);
        }

        cliente.append("id_empresa", this.cliente.id_empresa);
        cliente.append("nome", this.form.nome);
        cliente.append("cnpj_cpf", this.normalizeCpfCnpj(this.form.cnpj_cpf));
        cliente.append("ie_rg", this.form.ie_rg);
        cliente.append("responsavel", this.form.responsavel);
        cliente.append("cep", this.form.cep);
        cliente.append("logradouro", this.form.logradouro);
        cliente.append("numero", this.form.numero);
        cliente.append("bairro", this.form.bairro);
        cliente.append("fiscal", true);
        cliente.append("id_cidade", this.form.id_cidade);

        await this.$http.post("empresa/update-cliente", cliente);

        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );

        this.$toast.success("Cliente atualizado com sucesso!");

        submitButton.removeAttribute("disabled", "");
        this.$router.push({ name: "revendasLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
  computed: {
    ...mapGetters(["isNuts"]),
  },
};
